// eslint-disable-next-line
export function filterObj(obj, keys = []) {
  return Object.fromEntries(Object.entries(obj)
    .filter(([key]) => keys.includes(key)));
}
